<template>
  <div class="body1">
    <div class="content">
      <img class="logo" src="../assets/footer-logo.png">
      <div class="col">
        <div class="title">企业</div>
        <div class="section">
          <div class="row">易贝乐中国</div>
          <div class="row">荣誉殿堂</div>
          <div class="row">公司新闻</div>
          <div class="row">全国校区</div>
          <div class="row">加入易贝乐</div>
          <div class="row">加盟合作</div>
        </div>
      </div>
      <div class="col">
        <div class="title">来易贝乐学习<br/>是因为</div>
        <div class="section">
          <div class="row">2—3岁<br/>幼儿启蒙兴趣培养课程<br/>Ele-Babies</div>
          <div class="row">3—6岁<br/>儿童英语基础奠定课程<br/>Ele-T</div>
          <div class="row">6—12岁<br/>少儿英语腾飞课程<br/>Ele-Kids</div>
        </div>
      </div>
      <div class="col">
        <div class="title">家长知识园地</div>
        <div class="section">
          <div class="row">英语知识</div>
          <div class="row">儿童心理</div>
          <div class="row">EFL专栏</div>
          <div class="row">学员小咖秀</div>
        </div>
      </div>
      <div class="col focus">
        <div class="title">关注我们</div>
        <div class="information">
          <img class="tel-icon" src="../assets/wechat.png">
          <img class="tel-icon" src="../assets/call-tel.png">
          <div>
            <div>周一至周日：9:00-19:00</div>
            <a class="tel" href="tel:400-6161-523">400-6161-523</a>
          </div>
        </div>
        <div class="address">
          总部地址：<br/>北京市朝阳区三间房东路一号北京懋隆文化产业创意园内第二十栋西区A座<br/>京ICP备15055262号-2 京公网安备1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../assets/style/index";
.body1{
  height: 180px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: #5A5657;
  .content{
    display: none;
    .media-content;
    height: 100%;
    // display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding: 35px 10px 0 10px;
    box-sizing: border-box;
    color: white;
    .logo{
      width: 116px;
      height: 106px;
      margin-right: 30px;
    }
    .col{
      flex: 1;
      &.focus{
        flex: 2;
      }
      .title{
        font-weight: Bold;
        font-family: 'SourceHanSansCN-Bold', Helvetica, Arial, sans-serif;
        font-size: 20px;
        line-height: 24px;
      }
      .section{
        margin-top: 35px;
        margin-bottom: 35px;
        font-size: 18px;
        font-family: 'MicrosoftYaHei', Helvetica, Arial, sans-serif;
        margin-bottom: ~'calc(constant(safe-area-inset-bottom) + 35px)';
        margin-bottom: ~'env(constant(safe-area-inset-bottom) + 35px)';
      }
      .tel-icon{
        width: 46px;
        height: 46px;
        margin-right: 20px;
      }
      .information{
        display: flex;
        flex-direction: row;
        margin-top: 35px;
        .tel{
          font-size: 27px;
          font-weight: bold;
          color: white;
          text-decoration: none;
        }
      }
      .address{
        font-size: 14px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/e-footer.vue